import React from 'react';
import NotesRepositoryWidgetBuilder from './NotesRepositoryWidgetBuilder';
import NotesRepositoryWidgetRenderer from './NotesRepositoryWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { NotesRepositoryWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNoteSticky } from '@fortawesome/free-solid-svg-icons';

export { default as NotesRepositoryWidgetBuilder } from './NotesRepositoryWidgetBuilder';
export { default as NotesRepositoryWidgetRenderer } from './NotesRepositoryWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'notes_repository',
  meta: {
    label: 'Notes Repository',
    icon: React.createElement(FontAwesomeIcon, { icon: faNoteSticky }),
    description: 'Store and organize text notes with tags',
    isSystem: true,
    isCreatable: false,
    shareable: true,
    dataFlow: 'both',
  },
  defaultSize: { w: 6, h: 5, minW: 5, minH: 5 },
  defaultConfig: () => ({
    allowCreate: true,
    allowDelete: true,
    allowTagging: true,
    gridView: true,
    enableMarkdown: true,
  } as NotesRepositoryWidgetConfig),
  Builder: NotesRepositoryWidgetBuilder,
  Renderer: NotesRepositoryWidgetRenderer,
  Preview,
};
